import React from 'react';
import { useSelector } from 'react-redux';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn } from '~/components/EditAndAddItem';
import PickSqCheckBox from '~/components/CheckBox/PickSqCheckBox';

const actionList = [
    { name: '安裝中', value: '安裝中' },
    { name: '安裝完成', value: '安裝完成' },
    { name: '安裝準備', value: '安裝準備' },
    { name: '安裝暫停', value: '安裝暫停' },
];

const Sub5GridConnection = (props) => {
    const { gridConnectionActionType, shipId, shipName, titleWidth, disabled, returnInputValue, changeData, data, z, d } = props;
    const setList = useSelector((state) => state.data.PPDailySeatList);

    const getInitialDataArray = () => {
        const sub5 = data.sub5_grid_connection || [];
        const initialDataArray = sub5.filter((o) => o.type_name === d && o.zone_name === z && o.grid_connection_action_type === gridConnectionActionType);

        if (initialDataArray.length === 0) {
            initialDataArray.push({
                base_days: '',
                base_name: '',
                base_num: '',
                ischeck: '0',
                type_name: d,
                zone_name: z,
                ship_id: shipId || "",
                ship_name: shipName || "",
                base_action: '',
                grid_connection_action_type: gridConnectionActionType,
                is_delete: false,
            });
        }
        return initialDataArray;
    };

    const saveSubData = (newDataArray) => {
        const sub5 = data.sub5_grid_connection || [];
        const updatedDataArray = sub5.filter((o) => o.type_name !== d || o.zone_name !== z || o.grid_connection_action_type !== gridConnectionActionType);
        updatedDataArray.push(...newDataArray);
        changeData({ label: 'sub5_grid_connection', data: updatedDataArray });
    };

    const addRow = () => {
        const newDataArray = [...dataAry];
        newDataArray.push({
            base_days: '',
            base_name: '',
            base_num: '',
            ischeck: '0',
            type_name: d,
            zone_name: z,
            ship_id: shipId || "",
            ship_name: shipName || "",
            base_action: '',
            grid_connection_action_type: gridConnectionActionType,
            is_delete: false,
        });
        saveSubData(newDataArray);
    };

    const delRow = (index) => {
        const newDataArray = [...dataAry];

        if (newDataArray[index]['id']) {
            newDataArray[index].is_delete = true;
        } else {
            newDataArray.splice(index, 1);
        }
        saveSubData(newDataArray);
    };

    const dataAry = getInitialDataArray();

    const renderRow = (o, i) => {
        const isCheck = o.ischeck === '1';

        const handleCheckBoxClick = () => {
            o.ischeck = isCheck ? '0' : '1';
            saveSubData([...dataAry]);
        };

        const handleNameChange = (data) => {
            o.base_name = data;
            saveSubData([...dataAry]);
        };

        const handleNumberChange = (data) => {
            o.base_num = data;
            saveSubData([...dataAry]);
        };

        const handleActionChange = (data) => {
            o.base_action = data;
            saveSubData([...dataAry]);
        };

        const handleAddButtonClick = (i > 0) ? () => delRow(i) : () => addRow();

        return (
            !o.is_delete &&
            <EAA_Row key={`PPDaily_Area_Schedule_Sub5_${z}_${d}_${i}`}>
                <EAA_Item>
                <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth + 20} />
                    <PickSqCheckBox disabled={disabled} value={isCheck} onClick={handleCheckBoxClick} />
                    <div style={{ marginLeft: 8, marginRight: 8 }}>第</div>
                    <div style={{ width: 103, display: 'flex' }}>
                        <EAA_Select
                            displayBorder
                            disabled={disabled || !isCheck}
                            marginRight={0}
                            list={setList}
                            value={returnInputValue(o.base_name)}
                            onChange={handleNameChange}
                        />
                    </div>
                    <div style={{ marginLeft: 8, marginRight: 8 }}>{'座 (編號'}</div>
                    <EAA_Input
                        displayBorder
                        disabled={disabled || !isCheck}
                        marginRight={0}
                        hint="詳答編號"
                        value={returnInputValue(o.base_num)}
                        onChange={handleNumberChange}
                    />
                    <div style={{ marginLeft: 8, marginRight: 8 }}>{')'}</div>
                    <div style={{ width: 165, display: 'flex' }}>
                        <EAA_Select
                            displayBorder
                            disabled={disabled || !isCheck}
                            marginRight={8}
                            list={actionList}
                            value={returnInputValue(o.base_action)}
                            onChange={handleActionChange}
                        />
                    </div>
                    <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={handleAddButtonClick} />
                </EAA_ItemContainer>
                </EAA_Item>
            </EAA_Row>
        );
    };

    return dataAry.map((o, i) => renderRow(o, i));
};

export default Sub5GridConnection;
